import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

window.customElements.define('photosmith-app-hub', wrap(Vue, () => import('~root/src/components/build/AppHub.vue?shadow')))

window.customElements.define('photosmith-apps-dashboard', wrap(Vue, () => import('~root/src/components/build/AppsDashboard.vue?shadow')))

window.customElements.define('photosmith-apps-main-menu', wrap(Vue, () => import('~root/src/components/build/AppsMainMenu.vue?shadow')))

window.customElements.define('photosmith-composite', wrap(Vue, () => import('~root/src/components/build/Composite.vue?shadow')))

window.customElements.define('photosmith-details', wrap(Vue, () => import('~root/src/components/build/Details.vue?shadow')))

window.customElements.define('photosmith-directory-menu-schools-list', wrap(Vue, () => import('~root/src/components/build/DirectoryMenuSchoolsList.vue?shadow')))

window.customElements.define('photosmith-directory-subjects', wrap(Vue, () => import('~root/src/components/build/DirectorySubjects.vue?shadow')))

window.customElements.define('photosmith-districts', wrap(Vue, () => import('~root/src/components/build/Districts.vue?shadow')))

window.customElements.define('photosmith-districts-edit', wrap(Vue, () => import('~root/src/components/build/DistrictsEdit.vue?shadow')))

window.customElements.define('photosmith-drive', wrap(Vue, () => import('~root/src/components/build/Drive.vue?shadow')))

window.customElements.define('photosmith-external-side-bar', wrap(Vue, () => import('~root/src/components/build/ExternalSideBar.vue?shadow')))

window.customElements.define('photosmith-hello-world', wrap(Vue, () => import('~root/src/components/build/HelloWorld.vue?shadow')))

window.customElements.define('photosmith-hi', wrap(Vue, () => import('~root/src/components/build/Hi.vue?shadow')))

window.customElements.define('photosmith-integration', wrap(Vue, () => import('~root/src/components/build/Integration.vue?shadow')))

window.customElements.define('photosmith-modal-photo-web-cam', wrap(Vue, () => import('~root/src/components/build/ModalPhotoWebCam.vue?shadow')))

window.customElements.define('photosmith-school-apps-settings', wrap(Vue, () => import('~root/src/components/build/SchoolAppsSettings.vue?shadow')))

window.customElements.define('photosmith-school-import-subjects', wrap(Vue, () => import('~root/src/components/build/SchoolImportSubjects.vue?shadow')))

window.customElements.define('photosmith-school-logs', wrap(Vue, () => import('~root/src/components/build/SchoolLogs.vue?shadow')))

window.customElements.define('photosmith-school-transactions', wrap(Vue, () => import('~root/src/components/build/SchoolTransactions.vue?shadow')))

window.customElements.define('photosmith-school-wallet', wrap(Vue, () => import('~root/src/components/build/SchoolWallet.vue?shadow')))

window.customElements.define('photosmith-schools-left-list', wrap(Vue, () => import('~root/src/components/build/SchoolsLeftList.vue?shadow')))

window.customElements.define('photosmith-schools-stats-table', wrap(Vue, () => import('~root/src/components/build/SchoolsStatsTable.vue?shadow')))

window.customElements.define('photosmith-side-bar', wrap(Vue, () => import('~root/src/components/build/SideBar.vue?shadow')))

window.customElements.define('photosmith-student-table-left', wrap(Vue, () => import('~root/src/components/build/StudentTableLeft.vue?shadow')))

window.customElements.define('photosmith-users-table', wrap(Vue, () => import('~root/src/components/build/UsersTable.vue?shadow')))

window.customElements.define('photosmith-vip-subjects', wrap(Vue, () => import('~root/src/components/build/VipSubjects.vue?shadow')))

window.customElements.define('photosmith-serg-backup_-student-table-left', wrap(Vue, () => import('~root/src/components/build/sergBackup_StudentTableLeft.vue?shadow')))